const Field = ({ children, isFullWidth }) => {
    return (
        <div className={`main-content__form-group ${isFullWidth ? "main-content__form-group--full" : ""} `}>
            {children}
        </div>
    );
};

export default Field;
